export default __webpack_public_path__ + "static/media/sketch-corporate-tn.1496a85b.png";